function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#492cbd;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-headphones",
  "data-name": "Icon feather-headphones",
  transform: "translate(478.5 623.92)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9654",
  "data-name": "Path 9654",
  className: "cls-2",
  d: "M4.5 18.014v-5.406a8.108 8.108 0 1 1 16.216 0v5.405"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9655",
  "data-name": "Path 9655",
  className: "cls-2",
  d: "M20.716 25.5a1.8 1.8 0 0 1-1.8 1.8h-.9a1.8 1.8 0 0 1-1.8-1.8v-2.7a1.8 1.8 0 0 1 1.8-1.8h2.7zM4.5 25.5a1.8 1.8 0 0 0 1.8 1.8h.9A1.8 1.8 0 0 0 9 25.5v-2.7A1.8 1.8 0 0 0 7.2 21H4.5z",
  transform: "translate(0 -6.59)"
}));

function SvgTalkToUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_9106",
    "data-name": "Group 9106",
    transform: "translate(-464 -609.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9659",
    "data-name": "Path 9659",
    d: "M27.5 0A27.5 27.5 0 1 1 0 27.5 27.5 27.5 0 0 1 27.5 0z",
    transform: "translate(464 609.42)",
    style: {
      fill: "#492cbd",
      opacity: 0.063
    }
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToUs);
export default __webpack_public_path__ + "static/media/talk-to-us.09271dff.svg";
export { ForwardRef as ReactComponent };